$eve_segmented $eve_selection_single
	variant \solid
	colors \low
	size? \m
	plate_width? \
	plate_inset_start? \
	plate_border_radius? \
	sub /
		<= Options_container $eve_flex
			sub /
				<= Plate $eve_surface
					interactive? false
					colors \lowest
					style *
						width <= plate_width
						insetInlineStart <= plate_inset_start
						- borderRadius <= plate_border_radius
				^ segments /
					<= Segment* $eve_segmented_option
						selected <= option_selected*
						label <= option_label*
						event_click?event <=> option_click*?event
